<template>
  <div style="text-align: center;">
      <span class="info">{{status.info}}</span>
      <span v-if=" typeof status.message === 'string' && status.message.includes('Exception')"  style="color: red; font-weight: bold" class="info-exception"> Status: {{ status.message }}</span>
      <span v-else class="info-exception">Status: {{ status.message }}</span>

      <h3> Step 3: Select Payments on Invoices </h3>
      <p class="p-h3"> Check all transactions you'd like to mark as Paid. </p>

      <!-- Nav bar -->
      <div class="nav-bar" style=" display: inline-block;">
        <div class="progress-area" v-if="status.status == 'PROGRESS'">
            <div v-if="task_percent ==''" class="loader"></div>
    
            <div v-else class="progress-area-block">
                <label for="file" class="progress-area-block-label">Progress: {{task_percent}}% </label>
                <progress id="file" :value="task_percent" max="100" style="height: 40px;"> {{task_percent}}% </progress>
            </div>
        </div>
        <div class="all_table">
            <div class="invoices">
                <table v-for="(invoice, idx) in invoices" v-bind:key="idx" style="width:920px;">
                    <thead>
                        <tr>
                            <th>INV</th>
                            <th></th>
                            <th>BANK</th>
                        </tr>
                    </thead>
                    <tr>
                        <td>
                            <h4 style="margin-left: 1px;"> File Name : {{ invoice.file_name.split('__')[0] }}.pdf </h4>
                            <table style="width:470px; float: left; margin-right:20px; border:2px;" rules="all">
                                <col width="10%" /> 
                                <col width="25%"/>
                                <col/>
                                <col/>
                                <col/>
                                <thead>
                                    <tr>
                                        <th>
                                            <input v-if = "invoice.bank_info === 'found' && invoice.match_cnt > 0" type="checkbox" :value="idx*1000" @click="selectAll(idx)" v-model="checkBoxList">
                                            <input v-else type="checkbox" disabled>
                                        </th>
                                        <th>Invoice</th>
                                        <th>Status</th>
                                        <th>Invoice Amount</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(payment, idy) in invoice.list_payments" v-bind:key="idy">
                                        <td>
                                            <input v-if = "invoice.bank_info === 'found' && (payment.status === 'Amount Matched!' || payment.status.startsWith('Statement Matched!'))" type="checkbox" :inv="payment.number" :pamount="payment.amount" :pdate="invoice.payment_date" :total_amount="invoice.total_amount" v-model="checkBoxList" :value="idx*1000 + idy + 1">
                                            <input v-else-if = "invoice.bank_info === 'not_found' || (payment.status !== 'Amount Matched!' && !payment.status.startsWith('Statement Matched!'))" type="checkbox" disabled >
                                        </td>
                                        <td>{{ payment.number }}</td>
                                        <td v-if="payment.status=='Amount Matched!' || payment.status.startsWith('Statement Matched!')" style="color: green ; font-weight: bold">{{ payment.status }}</td>
                                        <td v-else-if="payment.status.includes('Already')" style="color: #3498db ; font-weight: bold">{{ payment.status }}</td>
                                        <td  v-else style = "color: red ; font-weight: bold" >{{ payment.status}}</td>
                                        <td> ${{ payment.amount}}</td>
                                        <td>{{ invoice.payment_date }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table style="width:770px; float: left; margin-right:20px; border:2px;" rules="all" v-if= "invoice.error_lines.length > 0"  > 
                                <thead>
                                    <th> Remit File: {{ invoice.file_name.split('__')[0] }}.pdf     Error Lines</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(error_line, idz) in invoice.error_lines" v-bind:key="idz">
                                        <td class="error_row"> {{ error_line }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td>
                            <table style="width:100px; float:right; position: relative; margin-right:1px;" rules="all"  v-if="bank_invoices[idx].amount!=false">
                                <tr>
                                    <td style="color: green ; font-weight: bold"><b>MATCH</b></td>
                                </tr>
                            </table>
                            <table style="width:100px; float:right; position: relative; margin-right:1px;" rules="all" v-else >
                                <tr>
                                    <td style="color: red ; font-weight: bold"><b>NO MATCH</b></td>
                                </tr>
                            </table>
                        </td>
                        <td>
                            <h4 style="margin-left: 1px;"> File Name : {{ bank_invoices[idx]['file_name'].split('__')[0] }}.csv </h4>
                            <table style="width:270px; float: right; margin-right:20px; position: relative; border:2px;" rules="all"  v-if="bank_invoices[idx].amount!=false">
                                <tr>
                                    <td><b>Bank ID</b></td>
                                    <td style="font-weight: bold"> {{bank_invoices[idx].bank_reference}}</td>
                                </tr>
                                <tr>
                                    <td><b>ACH Details</b></td>
                                    <td v-if="bank_invoices[idx].transaction_details.includes('Duplicate in Bank ACH file') " style="color: red; font-weight: bold">{{bank_invoices[idx].transaction_details}}</td>
                                    <td v-else style = " font-weight: bold" > {{bank_invoices[idx].transaction_details}}</td>
                                </tr>
                                <tr>
                                    <td><b>Amount</b></td>
                                    <td style="font-weight: bold">${{ bank_invoices[idx].amount }}</td>
                                </tr>
                                <tr>
                                    <td><b>Status</b></td>
                                    <td>CLEARED</td>
                                </tr>
                                <tr>
                                    <td><b>Date</b></td>
                                    <td style="font-weight: bold">{{bank_invoices[idx].post_date}}</td>
                                </tr>
                            </table>
                            <table style="width:270px; float:right; position: relative; margin-right:20px; border:2px;" rules="all" v-else >
                                <tr>
                                    <td><b>Bank ID</b></td>
                                    <td>None</td>
                                </tr>
                                <tr>
                                    <td><b>Details</b></td>
                                    <td>None</td>
                                </tr>
                                <tr>
                                    <td><b>Amount</b></td>
                                    <td>${{ bank_invoices[idx].amount }}</td>
                                </tr>
                                <tr>
                                    <td><b>Status</b></td>
                                    <td>CLEARED</td>
                                </tr>
                                <tr>
                                    <td><b>Date</b></td>
                                    <td>{{bank_invoices[idx].post_date}}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
            <div>
                <div>
                    <div class="buttons-area">
                        <div>
                            <button v-on:click='ApproveTask' :disabled="isSubmitting || status.status == 'PROGRESS' || this.checkBoxList.length <= invoices.length">{{ isSubmitting ? 'Submitting...' : 'Mark Selected Invoices as Paid' }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


      </div>
  </div>
</template>

<script>
  import api from '../services/api';

  export default {
    data () {
      return {
        status: {},
        bank_invoices: [],
        invoices: [],
        task_percent:'',
        scan_interval : 2000,
        checkBoxList: [],
        checkBoxStatus:[],
        inisialized :false,
        isSubmitting: false,
      }
    },
    methods: {
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        async ApproveTask() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;

            console.log('go to COMPLETE №1!');
            let formData = [];
            console.log('bank_file_lenght',this.bank_invoices.length);
            console.log('bank_invoices',this.bank_invoices);
            console.log(document.querySelectorAll('input[type="checkbox"]').length);
            for( var i = 0; i < document.querySelectorAll('input[type="checkbox"]').length; i++ ){
                // console.log(document.querySelectorAll('input[type="checkbox"]')[i].outerHTML,document.querySelectorAll('input[type="checkbox"]')[i].outerHTML.split(' ').length)
                if (document.querySelectorAll('input[type="checkbox"]')[i].checked && document.querySelectorAll('input[type="checkbox"]')[i].outerHTML.split(' ').length > 5) {

                    let inv = document.querySelectorAll('input[type="checkbox"]')[i].outerHTML.split(' ')[3].split('=')[1].replace(/"([^"]+(?="))"/g, '$1');
                    let amount = document.querySelectorAll('input[type="checkbox"]')[i].outerHTML.split(' ')[4].split('=')[1].replace(/"([^"]+(?="))"/g, '$1');
                    let date = document.querySelectorAll('input[type="checkbox"]')[i].outerHTML.split(' ')[5].split('=')[1].replace(/"([^"]+(?="))"/g, '$1');
                    let total_amount = document.querySelectorAll('input[type="checkbox"]')[i].outerHTML.split(' ')[6].split('=')[1].replace(/"([^"]+(?="))"/g, '$1');
                    formData.push({
                        "inv_number":inv,
                        "amount": amount,
                        "payment_date":date,
                        "total_amount":total_amount,
                    });
                    }
                else
                    continue}
            console.log('---------------');
            console.log('formData',formData);
            console.log('---------------');
            api.post('/complete', {content:formData}, {
                headers: {
                'Content-Type': 'application/json'
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    console.log('go to COMPLETE №2!');
                    this.invoices = [];
                    console.log(this.invoices);
                    this.$router.push({name:'CompletePage'})}
            })
            .catch(() => {
                console.log('Error!');
                this.isSubmitting = false;
            });
        },

        async getResult() {
            try {
                let response = await api.post('/get_result');
                if (response.status == 200) {
                    this.status = response.data
                    this.task_percent = response.data['message'] ?? 0;
                    // console.log("data",response.data['data'])
                    if (response.data['data']!=''){
                        this.bank_invoices = response.data['data']['bank_invoices'] ?? [];
                        this.invoices = response.data['data']['invoices'] ?? [];
                        this.task_percent = response.data['message'];
                        // Only initialize checkboxes once the backend reports the
                        // comparison finished (DONE). Before that, invoices still
                        // carry the default bank_info='not_found' / match_cnt=0
                        // placeholders written during Phase 1, which would render
                        // every row disabled and cause "Select All" to push zero
                        // line items — forcing the user to hard-refresh to recover.
                        const workflowStatus = response.data['status'];
                        const readyToInit = workflowStatus === 'DONE'
                            && this.invoices.length > 0
                            && this.invoices.every(inv => typeof inv.match_cnt !== 'undefined');
                        if (this.inisialized == false && readyToInit){
                            this.formCheckbox().then(result => {
                                console.log('Checkbox Initialized',result);
                            })
                            this.initedChecked().then(result => {
                                console.log('Clicked !',result);
                            this.inisialized = true;
                            })
                        }
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        // TO DO multi table
        async formCheckbox(){
            let checkBoxStatus = []
            for (var i = 0; i < this.invoices.length; i++){
                checkBoxStatus.push({});
                checkBoxStatus[i]['match_cnt'] = this.invoices[i]['match_cnt']
                checkBoxStatus[i]['valid_invs'] = this.invoices[i]['valid_invs']
                checkBoxStatus[i]['isSelectAll'] = false
                console.log(this.checkBoxStatus)
            }
            this.checkBoxStatus = checkBoxStatus
        },

        selectAll: function(idx) {
            if (this.checkBoxStatus[idx]['isSelectAll']  == false){
                for (var i = 0; i <= this.checkBoxStatus[idx]['match_cnt']; i ++){
                this.checkBoxList.push(idx * 1000 + i)
                }
                this.checkBoxStatus[idx]['isSelectAll']  = true
                this.checkBoxList = [...new Set(this.checkBoxList)];

            }else{
                var arr = []
                for (var k = 0; k <= this.checkBoxStatus[idx]['match_cnt']; k ++){
                    arr.push(idx * 1000 + k)
                // console.log(arr)
                for( var p = 0; p < arr.length; p++){ 
                    for (var j = 0; j < this.checkBoxList.length; j++){
                        if ( arr[p] === this.checkBoxList[j]) { 
                        this.checkBoxList.splice(j, 1); 
                        }
                    }            
                }
                this.checkBoxStatus[idx]['isSelectAll']  = false
                }
            }
        },
        async initedChecked(){
            for (var i = 0 ; i < this.invoices.length; i ++){
                if (this.checkBoxStatus[i]['isSelectAll']  == false){
                    this.selectAll(i)
                }
            }
        },
        async getResults() {
            while(1 != this.state) {
                await this.getResult();
                await this.sleep(this.scan_interval)
            }
        },

    },
    mounted() {
      this.getResults()
    },
    name: 'CompareTransactions',
  }
</script>

<style scoped>
    h3, .p-h3 {
        text-align: left;
    }
    .nav-bar {
        width: 900px;
        margin: 0 auto;
        padding: 12px 32px 55px 22px;
        background: rgb(219, 227, 230);
        border: 0;
        border-radius: 4px;
    }

    .info {
        position: absolute;
        left: 8px;
        top: 8px;
        font-weight: bold;
        color: grey
    }

    .info-exception {
        position: absolute;
        left: 8px;
        top: 24px;
        font-weight: bold;
        color: grey
    }


    .router-link {
        text-decoration: none;
    }

    a {
        text-decoration: none;
    }

    .progress-area {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .progress-area-block {
        display: flex;
        align-items: center;
    }

    .progress-area-block-label {
        padding-right: 15px;
        font-weight: bold;
    }

    button {
        display: block;
        line-height: 38px;
        margin: 10px;
        text-align: center;
        padding: 0 30px;
        /* vertical-align: middle; */
        font-size: .875rem;
        color: #fff;
        background-color: #1e87f0;
        border: 1px solid transparent;
        font-weight: bold;
        border-radius: 4px;
    }

    .buttons-area {
        float: right;
        text-align: right;
    }

    button:disabled {
        background-color: #cccccc;
        color: #707070;
    }

    table {
        border-collapse: collapse;
        margin: 25px auto;
        font-size: 0.9em;
        font-family: sans-serif;
        width: 932px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
        table-layout:fixed;
    }

    th, td {
        padding: 12px 15px;
        word-wrap: break-word;
    }

    thead tr {
        background-color: #1e87f0;
        color: #ffffff;
        text-align: center;
        padding: 25px;
    }

    .error_row {
        font-weight: bold;
        text-align:left ;
        color:red ;
    }

    .loader {
        border: 8px solid #f3f3f3; /* Light grey */
        border-top: 8px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
        justify-content: center;
        display: inline-block;
    }


    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

</style>